import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import { useParams } from 'umi';
import FLink from '@/components/FLink';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import { Space } from 'antd';
import { FNodeShare } from '@/components/FNodeShare';
import FTooltip from '@/components/FTooltip';
import FComponentsLib from '@freelog/components-lib';
import defaultNodeCover from '@/assets/default-node-cover.png';
import FNodeCoverImage from '@/components/FNodeCoverImage';
import { history } from 'umi';
import * as AHooks from 'ahooks';
import { FTourMgr } from '@/utils/FTourMgr';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FIcons from '@/components/FIcons';

interface SiderProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function Sider({ dispatch, nodeManagerPage }: SiderProps) {
  const params = useParams();
  const id = params.id ?? '';
  AHooks.useMount(() => {
    FTourMgr.init('node.sider', [
      {
        element: self.document.getElementById('node.sider.visit'),
        title: FI18n.i18nNext.t('hotpots_nodemanager_link_domain'),
        topOffset: 10,
        rightOffset: 10,
        bottomOffset: 10,
        leftOffset: 10,
      },
      {
        element: self.document.getElementById('node.sider.copy'),
        title: FI18n.i18nNext.t('tours_nodemgnt_copylink'),
        topOffset: 10,
        rightOffset: 10,
        bottomOffset: 10,
        leftOffset: 10,
      },
      {
        element: self.document.getElementById('node.sider.share'),
        title: FI18n.i18nNext.t('tours_nodemgnt_share'),
        topOffset: 10,
        rightOffset: 10,
        bottomOffset: 10,
        leftOffset: 10,
      },
    ]);
  });

  return (
    <div className={styles.styles}>
      <div className={styles.header}>
        <div style={{ height: 35 }} />

        <div className={styles.cover}>
          <FNodeCoverImage
            src={nodeManagerPage.nodeCover || defaultNodeCover}
          // width={80}
          />
        </div>

        <div style={{ height: 20 }} />

        <div className={styles.title}>
          <FTooltip title={nodeManagerPage.nodeTitle || nodeManagerPage.nodeName} placement={'top'}>
            <div style={{ display: 'inline-block' }}>
              <FComponentsLib.FContentText
                type={'highlight'}
                text={nodeManagerPage.nodeTitle || nodeManagerPage.nodeName}
                singleRow
                style={{
                  maxWidth: 200,
                  textAlign: 'center',
                }}
              />
            </div>
          </FTooltip>
          <div style={{ height: 10 }} />
          <FTooltip title={nodeManagerPage.nodeUrl.replace(new RegExp(/http(s)?:\/\//), '')}>
            <div className={styles.nodeUrl}>
              <FComponentsLib.FContentText
                type={'highlight'}
                singleRow
                style={{
                  textAlign: 'center',
                  maxWidth: '100%',
                }}
              >
                {nodeManagerPage.nodeUrl.replace(new RegExp(/http(s)?:\/\//), '')}
              </FComponentsLib.FContentText>
            </div>
          </FTooltip>
          <div style={{ height: 10 }} />

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {nodeManagerPage.node_limitation === 'public' && (
              <FComponentsLib.FContentText
                type={'additional2'}
                text={`[${
                  // 公开访问
                  FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_public')
                  }]`}
              />
            )}

            {nodeManagerPage.node_limitation === 'private' && (
              <FComponentsLib.FContentText
                type={'additional2'}
                text={`[${
                  // 私密
                  FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_private')
                  }]`}
              />
            )}

            {nodeManagerPage.node_limitation === 'pause' && (
              <FComponentsLib.FContentText
                type={'additional2'}
                style={{ color: '#EE4040' }}
                text={`[${
                  // 暂停运营
                  FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_hidefromvisitor')
                  }]`}
              />
            )}
          </div>
          <div style={{ height: 20 }} />
          <Space size={30}>
            <div id={'node.sider.visit'} style={{ width: 'fit-content', height: 'fit-content' }}>
              <FComponentsLib.FTextBtn
                onClick={async () => {
                  self.open(nodeManagerPage.nodeUrl);
                }}
              >
                <FTooltip title={FI18n.i18nNext.tAuto('nodemgnt_btn_viewnode_tooltip')}>
                  <FIcons.FNavigate style={{ fontSize: 16 }} />
                </FTooltip>
              </FComponentsLib.FTextBtn>
            </div>
            <div id={'node.sider.copy'} style={{ width: 'fit-content', height: 'fit-content' }}>
              <FCopyToClipboard
                text={nodeManagerPage.nodeUrl}
                title={FI18n.i18nNext.t('nodemgnt_btn_copynodeaddr_tooltip')}
                iconStyle={{ fontSize: 16 }}
              />
            </div>
            <div id={'node.sider.share'} style={{ width: 'fit-content', height: 'fit-content' }}>
              <FNodeShare
                title={nodeManagerPage.nodeName}
                cardTitle={nodeManagerPage.nodeTitle || nodeManagerPage.nodeName}
                introduction={ 
                  nodeManagerPage.setting_nodeIntroduction ||
                  nodeManagerPage.setting_nodeInfo.introduction ||
                  ''
                }
                url={nodeManagerPage.nodeUrl}
                cover={nodeManagerPage.nodeCover}
                defaultCover={defaultNodeCover}
                onClickShare={() => {
                  FServiceAPI.Activity.pushMessageTask({
                    taskConfigCode: 'TS000803',
                    meta: { nodeId: nodeManagerPage.nodeId },
                  });
                  FServiceAPI.Activity.pushMessageTask({
                    taskConfigCode: 'TS000034',
                    meta: { nodeId: nodeManagerPage.nodeId },
                  });
                  FServiceAPI.Activity.pushMessageTask({
                    taskConfigCode: 'T0003004',
                    meta: { nodeId: nodeManagerPage.nodeId },
                  });
                  FServiceAPI.Activity.pushMessageTask({
                    taskConfigCode: 'TS000076',
                    meta: { nodeId: nodeManagerPage.nodeId },
                  });
                }}
              >
                <FComponentsLib.FTextBtn>
                  <FTooltip title={FI18n.i18nNext.tAuto('nodemgnt_btn_sharenode_tooltip')}>
                    <FIcons.FShare style={{ fontSize: 16 }} />
                  </FTooltip>
                </FComponentsLib.FTextBtn>
              </FNodeShare>
            </div>
          </Space>
        </div>

        <div style={{ height: 35 }} />

        <div className={styles.navs}>
          <a
            className={nodeManagerPage.showPage === 'exhibit' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'exhibit',
                }),
              );
            }}
          >
            {FI18n.i18nNext.tAuto('tab_manage_nodes')}
          </a>
          <a
            className={nodeManagerPage.showPage === 'theme' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'theme',
                }),
              );
            }}
          >
            {FI18n.i18nNext.tAuto('manage_theme')}
          </a>
          <a
            className={nodeManagerPage.showPage === 'contract' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'contract',
                }),
              );
            }}
          >
            {
              // 合约管理
              FI18n.i18nNext.tAuto('nodemgnt_tab_contracmgnt')
            }
          </a>
          <a
            className={nodeManagerPage.showPage === 'transaction' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'transaction',
                }),
              );
            }}
          >
            {
              // 交易记录
              FI18n.i18nNext.tAuto('nodemgnt_tab_transactionshistory')
            }
          </a>
          <a
            className={nodeManagerPage.showPage === 'income' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'income',
                }),
              );
            }}
          >
            {
              // 收入结算
              FI18n.i18nNext.tAuto('nodemgnt_tab_payouts')
            }
          </a>
          <a
            className={nodeManagerPage.showPage === 'setting' ? styles.activated : ''}
            onClick={() => {
              history.push(
                FUtil.LinkTo.nodeManagement({
                  nodeID: nodeManagerPage.nodeId,
                  showPage: 'setting',
                }),
              );
            }}
          >
            {
              // 节点设置
              FI18n.i18nNext.tAuto('nodemgnt_tab_nodesetting')
            }
          </a>
        </div>
      </div>

      <div className={styles.gotoTest}>
        <span>{FI18n.i18nNext.tAuto('msg_navigate_to_test_node')}</span>
        &nbsp;
        <FLink
          to={FUtil.LinkTo.informNodeManagement({
            nodeID: Number(id),
            showPage: 'exhibit',
          })}
          target='_blank'
        >
          {FI18n.i18nNext.tAuto('btn_navigate_to_test_node')}
        </FLink>
      </div>
    </div>
  );
}

export default connect(({ nodeManagerPage }: ConnectState) => ({
  nodeManagerPage,
}))(Sider);
